import { useEffect } from 'react'
import { SUPPORT_LINKS } from '~/shared/lib/constants/links/links'

function FallbackComponent() {
  useEffect(() => {
    const target = document.querySelector('.block') as HTMLElement | null
    if (target) {
      const header = document.querySelector('header') as HTMLElement | null
      if (header) {
        target.style.minHeight = `calc(100vh - ${header.offsetHeight + 3}px)`
      }
    }
  }, [])

  return (
    <div className="block flex items-center justify-center w-full min-h-screen bg-gradient-to-r bg-white">
      <div className="px-6 py-10 rounded-lg sm:px-12 sm:py-16 lg:px-20 lg:py-24">
        <div className="flex flex-col items-center">
          <h6 className="mb-2 text-2xl font-bold text-center text-gray-800 md:text-3xl">
            Что-то пошло не так!
          </h6>
          <div className="text-center mb-6">
            <p className="text-center text-gray-500 md:text-lg">
              Мы уже знаем об этом. Пожалуйста, обновите страницу через пару
              минут или напишите нам:
            </p>
            <a
              href={SUPPORT_LINKS.TELEGRAM}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 md:text-lg"
            >
              {SUPPORT_LINKS.TELEGRAM}
            </a>
          </div>
          <a
            href="/"
            className="px-6 py-2 text-sm font-semibold text-blue-800 bg-blue-100"
          >
            Перейти на главную
          </a>
        </div>
      </div>
    </div>
  )
}

export function fallbackRender() {
  return <FallbackComponent />
}
